module.exports = __webpack_public_path__ + "img/xia3.50ee6d0d.png";